import React from "react";

const FormInput = ({
  type,
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  className,
  readOnly,
  checked,
  maxLength
}) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      className={className}
      readOnly={readOnly}
      checked={checked}
      maxLength={maxLength}
    />
  );
};

export default FormInput;
